export const CashHandlingTypes = Object.freeze({
  in: 'cash_inflow',
  out: 'cash_outflow'
})

export const cashierAlreadyClosedError = '043::012::016'
export const cashierAlreadyOpenedError = '044::012::017'
